import {StickyHeaderPositioning} from 'notebook/tables/core-ui/StickyHeaderHandler';
import * as TableConstants from 'notebook/tables/TableConstants';

export interface TableEditableState {
  headerWidth: number;
  tableWrapperWidth: number;
  hideHoverCell: boolean;
  isAffixed: boolean;
  isInsertingRows: boolean;
  multiActive: string | boolean | null; // null if selection is not being updated
  // TODO: I suspect this is a bug and should be read from this.props
  multiEditing?: boolean;
  multiEndIndex: TableConstants.TableIndex | null; // index selection ended on
  multiActualIndex: TableConstants.TableIndex | null;
  // stateful index to keep track during navigation (could be in a merged cell)
  multiExtra: {
    fillDownActive?: boolean;
    fillDownInvalid?: boolean;
    fillDownBox?: TableConstants.MultiSelectionBox | null;
  }; // any state that should be tied to the selection's existence
  multiSelIndex: TableConstants.TableIndex | null; // currently selected index within the selection
  multiStartIndex: TableConstants.TableIndex | null; // anchor index / index selection started on
  draggingDimension: TableConstants.TableDimension | null;
  rowHeights: Array<number>;
  showRenameTableModal: boolean;
  showSetSelectorModal: boolean;
  /** is the table in position to show a sticky header */
  canShowStickyHeader: boolean;
  stickyHeaderPositioning?: StickyHeaderPositioning;
  pagePaddingTop: number;
  pagePaddingBottom: number;
  lockedRowIndices: Array<number>;
  scrollToIndexAfterUpdate: number | null;
  currentFixedTableHeight: TableConstants.MaximumTableHeightType | null;
  tableCellEditorIsLoading: boolean;
  hasScrolledSinceEdit: boolean;
}

export const TABLE_EDITABLE_DEFAULT_STATE = {
  isInsertingRows: false,
  draggingDimension: null,
  rowHeights: [],
  isAffixed: false,
  headerWidth: 0,
  tableWrapperWidth: 0,
  showSetSelectorModal: false,
  showRenameTableModal: false,
  canShowStickyHeader: false,
  stickyHeaderPositioning: undefined,
  pagePaddingTop: 0,
  pagePaddingBottom: 0,
  multiStartIndex: null, // anchor index / index selection started on
  multiEndIndex: null, // index selection ended on
  multiActive: null, // null if selection is not being updated
  multiSelIndex: null, // currently selected index within the selection
  multiActualIndex: null, // stateful index to keep track during navigation (could be in a merged cell)
  multiExtra: {}, // any state that should be tied to the selection's existence
  hideHoverCell: false,
  lockedRowIndices: [],
  scrollToIndexAfterUpdate: null, // Will trigger scrolling to this index after the next component render
  currentFixedTableHeight: 0,
  tableCellEditorIsLoading: false,
  hasScrolledSinceEdit: false,
};
